<template>
  <!--
    KLASİK SERTİFİKA — HAZIR KAĞIT (PRE-PRINTED) MODU
    Kağıt matbaadan ön + arka yüz tamamen basılı (etiketler dahil) gelir.
    Uygulama SADECE değerleri basar: Ürün, Ölçü, Ağırlık, Ayar, Seri No + barkod + QR.
    Statik tasarım ekranda açık gri "kılavuz" olarak görünür ama yazıcıya gitmez.
    Değerler, tam tasarımdaki konumlarını birebir korur (visibility tekniği) ki
    fiziksel kağıttaki basılı etiketlerle hizalansın. offsetX/offsetY ile mm bazında
    ince ayar yapılır.
  -->
  <div class="cert-classic" :style="regStyle">
    <section class="face face-front">
      <div class="frame">
        <div class="corner tl"></div><div class="corner tr"></div>
        <div class="corner bl"></div><div class="corner br"></div>
        <div class="brand">
          <img src="/logo-af.png" alt="Altında Fırsat" />
          <div class="brand-name">ALTINDA FIRSAT</div>
        </div>
        <div class="title">ÜRÜN SERTİFİKASI</div>
        <div class="subtitle">Certificate of Authenticity</div>
        <div class="divider"></div>
        <p class="desc">
          Bu sertifika, satın aldığınız ürünün <strong>Altında Fırsat</strong> tarafından
          özenle hazırlandığını ve ürün özelliklerinin doğru bir şekilde tartılıp
          ölçüldüğünü belgeler.
        </p>
        <p class="usage">
          Arka yüzdeki <strong>QR kodu</strong> akıllı telefonunuzla okutarak ürünün
          tartım anındaki <strong>orijinal fotoğrafına</strong> ulaşabilirsiniz.
        </p>
        <div class="signature">
          <div class="sig-line"></div>
          <div class="sig-text">Yetkili İmza</div>
        </div>
      </div>
    </section>
    <section class="face face-back">
      <div class="frame">
        <div class="back-header">
          <img src="/logo-af.png" alt="Altında Fırsat" />
          <div>
            <div class="brand-mini">ALTINDA FIRSAT</div>
            <div class="brand-tag">Ürün Bilgileri</div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="info-grid">
          <div class="row"><span>Ürün</span><strong class="val">{{ item.productName || '-' }}</strong></div>
          <div class="row"><span>Ölçü</span><strong class="val">{{ item.size || '-' }}</strong></div>
          <div class="row"><span>Ağırlık</span><strong class="val">{{ item.weight != null ? item.weight + ' gr' : '-' }}</strong></div>
          <div class="row"><span>Ayar</span><strong class="val">{{ item.purityLabel || '-' }}</strong></div>
          <div class="row"><span>Seri No</span><strong class="val">{{ serial || '-' }}</strong></div>
        </div>
        <div class="codes">
          <barcode v-if="serial" :value="serial" format="CODE128" width="1.6" height="60" :displayValue="false" class="bar" />
          <img v-if="qrDataUrl" :src="qrDataUrl" class="qr" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import { certMixin } from "./_shared";
export default {
  components: { barcode: VueBarcode },
  mixins: [certMixin],
  props: {
    // Hazır kağıt hizalama ince ayarı (mm). Pozitif X = sağa, pozitif Y = aşağı.
    offsetX: { type: [Number, String], default: 0 },
    offsetY: { type: [Number, String], default: 0 },
  },
  computed: {
    regStyle() {
      const x = Number(this.offsetX) || 0;
      const y = Number(this.offsetY) || 0;
      return { "--reg-x": x + "mm", "--reg-y": y + "mm" };
    },
  },
};
</script>
<style scoped>
.cert-classic { font-family: 'Georgia', 'Times New Roman', serif; color: #1a1a1a; }
.face { width: 12.7cm; height: 8.89cm; background: #fffbf0; position: relative; box-sizing: border-box; padding: 0.5cm; overflow: hidden; page-break-after: always; }
.face:last-child { page-break-after: auto; }
.frame { width: 100%; height: 100%; border: 2px solid #b8902f; padding: 0.4cm 0.6cm; box-sizing: border-box; position: relative; display: flex; flex-direction: column; }
.corner { position: absolute; width: 14px; height: 14px; border: 2px solid #b8902f; background: #fffbf0; }
.tl { top: -8px; left: -8px; border-right: none; border-bottom: none; }
.tr { top: -8px; right: -8px; border-left: none; border-bottom: none; }
.bl { bottom: -8px; left: -8px; border-right: none; border-top: none; }
.br { bottom: -8px; right: -8px; border-left: none; border-top: none; }
.brand { display: flex; align-items: center; gap: 10px; }
.brand img { height: 36px; }
.brand-name { font-size: 13px; letter-spacing: 3px; font-weight: 700; color: #b8902f; }
.title { font-size: 22px; letter-spacing: 6px; text-align: center; margin-top: 8px; font-weight: 700; }
.subtitle { font-size: 11px; letter-spacing: 4px; text-align: center; color: #888; font-style: italic; margin-bottom: 6px; }
.divider { height: 1px; background: linear-gradient(to right, transparent, #b8902f, transparent); margin: 8px 0; }
.desc, .usage { font-size: 11.5px; line-height: 1.55; text-align: justify; margin: 4px 0; }
.usage { color: #555; }
.signature { margin-top: auto; text-align: right; }
.sig-line { width: 4cm; height: 1px; background: #555; margin-left: auto; }
.sig-text { font-size: 10px; color: #777; margin-top: 2px; font-style: italic; }
.back-header { display: flex; align-items: center; gap: 12px; }
.back-header img { height: 32px; }
.brand-mini { font-size: 12px; letter-spacing: 3px; font-weight: 700; color: #b8902f; }
.brand-tag { font-size: 10px; color: #888; letter-spacing: 1px; }
.info-grid { display: flex; flex-direction: column; gap: 4px; margin-top: 6px; }
.row { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 0; border-bottom: 1px dashed #d4b65a; }
.row span { color: #777; }
.row strong { color: #1a1a1a; }
.codes { margin-top: auto; display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; }
.bar { flex: 1; }
.qr { width: 2.2cm; height: 2.2cm; }

/* ===== HAZIR KAĞIT MODU ===== */
/* Ön yüz tamamen matbaada basılı: ne ekranda ne baskıda gösterilir. */
.cert-classic .face-front { display: none; }

/* Hizalama ince ayarı: tüm değer katmanı birlikte kayar (ekran + baskı). */
.cert-classic .face-back { transform: translate(var(--reg-x, 0mm), var(--reg-y, 0mm)); }

/* Ekran kılavuzu: matbaada basılı (statik) alanlar açık gri görünür, böylece
   kullanıcı değerlerin kağıttaki konumunu görüp X/Y ile hizalayabilir. */
.cert-classic .face-back { background: #ffffff; }
.cert-classic .frame { border-color: #e3e3e3; }
.cert-classic .back-header img { opacity: 0.15; }
.cert-classic .brand-mini,
.cert-classic .brand-tag { color: #cfcfcf; }
.cert-classic .row span { color: #c4c4c4; }
.cert-classic .row { border-bottom-color: #ededed; }
.cert-classic .divider { background: #ededed; }
/* Değer tek satırda kalır: uzun ürün adı sarmaz → satır yüksekliği sabit kalır
   → alttaki değerler aşağı kaymaz → basılı etiketlerle hizası korunur. Yatay
   konum (sağa hizalı) değişmez; aşırı uzun metin sona "…" ile kısalır. */
.cert-classic .row strong.val {
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 8cm;
}
</style>

<!--
  BASKI KURALLARI — UNSCOPED (BİLEREK).
  vue-barcode'un ürettiği <svg> JsBarcode tarafından oluşturulur ve Vue'nun
  scoped [data-v-*] attribute'unu ALMAZ. Bu yüzden baskıda "sadece değerler"
  görünürlük kurallarını scoped değil global blokta tutuyoruz ki .codes içindeki
  svg/img doğrudan eşleşsin (aksi halde barkod baskıda görünmeyebilir).
  Seçiciler .cert-classic ile öneklendiği için yalnızca bu bileşeni etkiler.
-->
<style>
@media print {
  .cert-classic { visibility: hidden; }
  .cert-classic .face-back {
    background: transparent !important;
    overflow: visible;            /* kenara yakın nudge'larda kırpılmasın */
    page-break-after: auto;       /* tek sayfa, fazladan boş sayfa yok */
  }
  /* SADECE değerler + barkod + QR mürekkep alır; diğer her şey görünmez ama
     kutuları yerinde kalır (visibility:hidden) → değerler birebir hizalı. */
  .cert-classic .row strong.val,
  .cert-classic .codes,
  .cert-classic .codes *,
  .cert-classic .codes svg,
  .cert-classic .codes img { visibility: visible !important; }
  .cert-classic .row strong.val { color: #000 !important; }
  .cert-classic .codes {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
